import React from "react";

const TalksAI = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          talksAI
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">talksAI</div>
    </div>
  );
};

export default TalksAI;
